var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dot-line"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"dot",class:{ active: _vm.isActive && (_vm.childLabel === 'Beef' || _vm.childLabel === 'Live Cattle'),
  active1: _vm.isActive && _vm.childLabel === 'Spot',
  active2: _vm.isActive && _vm.childLabel === 'Futures',
  active3: _vm.isActive && _vm.childLabel === 'Daily',
  active4: _vm.isActive && _vm.childLabel === 'Weekly'}}),_c('div',{staticClass:"line",class:{ hide: _vm.isLast }})])
}
var staticRenderFns = []

export { render, staticRenderFns }